import {Injectable} from '@angular/core';
import * as moment from "moment";
import {Store} from "@ngrx/store";
import {UUID} from "angular2-uuid";

import {AppState} from "@store/reducers";
import {SEARCH_RESULT_UPDATE, SEARCH_RESULT_ADD} from "@store/actions";
import {UserService} from "@services/user.service";
import {PackageDetailsService} from "@services/package-details.service";
import 'rxjs/add/operator/map';

@Injectable()
export class CreateConsignmentService {

  constructor(
    private store: Store<AppState>,
    private userService: UserService,
    private packageDetailsService: PackageDetailsService
  ) {}

  saveSearchResultToState(carriers, formData, deliveryTypes, id, search_id) {
    const data = carriers.reduce((shipments, {details, products}) => {
      products = this.deleteProductsWithErrors(products);
      const productsData = products.map(product => ({...product, carrierDetails: details}));
      return [...shipments, ...productsData];
    }, []);
    const total_weight = formData.packages.reduce(
      (total, {weight, quantity}) => total + (weight * quantity), 0);
    const searchResults = [];
    data.map((product) => {
      const {
        pickup_date,
        pickup_time_from,
        pickup_time_to,
        delivery_date,
        delivery_time_from,
        delivery_time_to,
        time_until_delivery,
        pickup_type,
        delivery_type,
        vat,
        charge,
        product_name,
        product_code,
        is_guaranteed,
        chargeable_weight,
        carrierDetails: {
          name,
          service_name,
          id: service_id
        },
        terms,
        product_id,
        currency,
        latest_booking_time,
      } = product;
      let pickup_time;
      if (pickup_time_from && pickup_time_to) {
        pickup_time = pickup_time_from + ' - ' + pickup_time_to;
      } else {
        pickup_time = formData.pickup_time;
      }
      let delivery_time;
      if (delivery_time_from && delivery_time_to) {
        delivery_time = delivery_time_from + ' - ' + delivery_time_to;
      }
      const deliveryTimeTo = ('0' + delivery_time_to).slice(-5);
      const localCharge: number = parseFloat(charge);
      const price = localCharge;
      const description = terms && terms.info ? terms.info : '';
      searchResults.push({
        service_id,
        pickup_date: String(moment(new Date(pickup_date)).format('YYYY-MM-DD')),
        pickup_time,
        delivery_date: String(moment(new Date(delivery_date)).format('YYYY-MM-DD')),
        delivery_time,
        time_until_delivery,
        pickup_type,
        delivery_type,
        delivery_type_name: deliveryTypes.find(({id}) => id === delivery_type).name,
        price,
        name,
        delivery_time_from,
        delivery_time_to: deliveryTimeTo,
        product_name,
        product_code,
        is_guaranteed,
        service_name,
        chargeable_weight,
        description,
        raiting: Math.floor(Math.random() * 5) + 1,
        votes: Math.floor(Math.random() * 16) + 5 + ' voters',
        total_weight,
        product_id,
        currency,
        charge,
        vat,
        pickup_time_from,
        pickup_time_to,
        latest_booking_time,
        // addons: product.addons,
        additional_services: product.additional_services,
        selected_additional_services: product.selected_additional_services
      });
    });
    // console.log('saveSearchResultToState', searchResults);
    this.store.dispatch({
      type: SEARCH_RESULT_UPDATE,
      payload: {
        products: searchResults,
        id: id,
        loaded: true,
        loading: false,
        search_id
      },
    });
  }

  deleteProductsWithErrors(products) {
    // Remove products with errors
    let index = products.length;
    while (index--) {
      if ('error' in products[index]) {
        products.splice(index, 1);
      }
    }

    return products;
  }

  saveSearchParamsToState(formData, searchResultId = null) {
    const {packages, pickupDateTime: {date: pickup_date, time: pickup_time}, ...rest} = formData;
    const params = {
      ...rest,
      ...this.packageDetailsService.getTotalPackagesData(formData.packages),
      packages: packages.map(pack => {
        const {length, width, height, ...rest} = pack;
        return {
          ...rest,
          length: length / 100,
          width: width / 100,
          height: height / 100
        };
      }),
      pickup_date,
      pickup_time
    };
    if (searchResultId) {
      this.store.dispatch({
        type: SEARCH_RESULT_UPDATE,
        payload: {
          params,
          id: searchResultId,
          products: [],
          loading: true,
          loaded: false
        },
      });
    } else {
      this.store.dispatch({
        type: SEARCH_RESULT_ADD,
        payload: {
          params,
          id: UUID.UUID(),
          products: [],
          loading: true,
          loaded: false
        },
      });
    }
  }
  saveAddress(form) {
    if (form.get('from.save_address').value === true) {
      this.userService.addAddressBook({
        ...form.get('from').value,
        alias: form.get('from.type').value === 'company' ?
          form.get('from.company_name').value :
          form.get('from.name').value + ' ' + form.get('from.surname').value,
        name: form.get('from.name').value,
        surname: form.get('from.surname').value,
        type: 0,
        company: form.get('from.type').value === 'company' ? 1 : 0,
        instructions: form.get('from.instructions').value,
        door_code: form.get('from.door_code').value
      }).subscribe();
    }
    if (form.get('to.save_address').value === true) {
      this.userService.addAddressBook({
        ...form.get('to').value,
        alias: form.get('to.type').value === 'company' ?
          form.get('to.company_name').value :
          form.get('to.name').value + ' ' + form.get('to.surname').value,
        name: form.get('to.name').value,
        surname: form.get('to.surname').value,
        type: 0,
        company: form.get('to.type').value === 'company' ? 1 : 0,
        instructions: form.get('to.instructions').value,
        door_code: form.get('to.door_code').value
      }).subscribe();
    }
  }

  preparePackages = (packages) => {
    return packages
      .map(({length, width, height, ...rest}) => {
        return {...rest, length: length / 100, width: width / 100, height: height / 100};
      });
  }

  prepareSearchData = (data) => {
    if (data.pickup && (data.pickup.is_used === null || data.pickup.is_used === false)) {
      delete data['pickup'];
    }

    if (data.delivery && (data.delivery.is_used === null || data.delivery.is_used === false)) {
      delete data['delivery'];
    }

    // remove useless fields
    const {
      alias, email, name, surname, phone, door_code, save_address,
      instructions, send_tracking_information,
      ...from
    } = data.from;
    const {
      alias: alias1, email: email1, name: name_1,
      surname: surname1, phone: phone1, door_code: door_code1,
      save_address: save_address1, instructions: instructions1,
      send_tracking_information: send_tracking_information1,
      ...to
    } = data.to;

    return {...data, from, to, packages: data.packages};
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/create-consignment.service.ts